import create from './create'
import deleteLang from './delete'
import exportLang from './export'

export default {
    create,
    'export': exportLang,
    'delete': deleteLang
}